
<template>
    <div class="center examplex">
        <vs-row class="pt-3 pb-3">
            <vs-col class="widthCard">
                <md-card class="text-center md-warn" md-with-hover v-if="cards.total_alumnos">
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{cards.total_alumnos}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">Total de alumnos</h4>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col class="widthCard" v-if="cards.monto_total">
                <md-card class="text-center md-info" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{cards.monto_total | currency}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">Monto Total</h4>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col class="widthCard mb-2" v-for="(nivel, key) in cards.niveles" :key="key">
                <md-card class="text-center md-danger" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{nivel}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">{{key}}</h4>
                            <p class="mb-0">Nivel Académico.</p>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
        </vs-row>
        
        <vs-button
            v-if="users != ''"
            color="#55ce63"
            relief
            :loading="loadingExcel"
            @click="getExcel()"
            class="ml-auto"
        >
            <i class="fas fa-download mr-2"></i> Descargar reporte
        </vs-button>
        <vs-row>
            <vs-col sm="12" lg="3" class="ml-auto">
                <vs-input v-model="search" placeholder="Buscar">
                    <template #icon>
                        <i class="fas fa-search"></i>
                    </template>
                </vs-input>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th>
                    Alumno
                </vs-th>
                <vs-th>
                    Ciclo escolar
                </vs-th>
                <vs-th>
                    Programa
                </vs-th>
                <vs-th>
                    Concepto
                </vs-th>
                <vs-th>
                    Monto total
                </vs-th>
                <vs-th>
                    Grupo
                </vs-th>
                <vs-th>
                    Acción
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in $vs.getSearch(users, search)"
                :data="tr"
            >
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.fullName }}</strong></p>
                    <p class="mb-0"><small>Matrícula</small><strong class="ml-1">{{ tr.matricula }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.ciclo }}</strong></p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.programa }}</strong></p>
                    <p class="mb-0"><small>Nivel Académico</small></p>
                    <p class="mb-0"><strong>{{ tr.nivel_academico }}</strong></p>
                </vs-td>
                <vs-td>
                    <div v-for="(concep, i) in tr.conceptos" :key="i">
                            <md-chip class="mb-1 fontMedium mini-chip col-blue"><strong> <small>{{ concep }} </small></strong></md-chip>
                    </div>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.monto_total | currency }}</strong></p>
                </vs-td>
                <vs-td>
                    <div v-for="(grup, i) in tr.grupos" :key="i">
                            <md-chip class="mb-1 fontMedium mini-chip col-yellow"><strong>{{ grup }}</strong></md-chip>
                    </div>
                </vs-td>
                <vs-td>
                    <vs-tooltip>
                        <vs-button
                            class="m-auto"
                            icon
                            color="success"
                            flat
                            blank
                            :href="'/finanzas/admin/' + window.btoa(tr.persona_id)"
                        >
                            <i style="font-size: 12px;" class="fas fa-external-link-alt"></i>
                        </vs-button>
                    <template #tooltip>
                        Ir a Gestión de finanzas
                    </template>
                </vs-tooltip>
                </vs-td>
            </vs-tr>
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
            <template #notFound>
                No hay información
            </template>
        </vs-table>        
    </div>
</template>
<script>
import reportes from '../../../../api/requests/reportes'
export default {
    props: [
        'parametros',
        'ejecutar',
        'institucionSelect',
        'instituciones',
        'ciclo'
    ],
    data:() => ({
        users: [],
        search: '',
        estatusColor: {
            'Prospecto': {
                'color': 'purple'
            },
            'Interesado': {
                'color': 'brown'
            },
            'Aplicante': {
                'color': 'blue'
            },
            'Admitido': {
                'color': 'green'
            },
            'Inscrito económico': {
                'color': 'blue'
            },
            'Congelado': {
                'color': 'pink'
            },
            'Descartado': {
                'color': 'pink'
            },
            'Inscrito académico': {
                'color': 'yellow'
            },
            'Acreditado en ciclo escolar': {
                'color': 'green'
            },
            'No acreditado en ciclo escolar': {
                'color': 'pink'
            },
            'Baja definitiva voluntaria': {
                'color': 'gray'
            },
            'Baja definitiva por conducta': {
                'color': 'gray'
            },
            'Baja temporal voluntaria': {
                'color': 'gray'
            },
            'Suspensión por morosidad': {
                'color': 'red'
            },
            'Bloqueo para inscripción': {
                'color': 'red'
            },
            'Reactivación': {
                'color': 'blue'
            },
        },
        page: 1, 
        max: 10,
        pages: 0,
        prospectos_total: '',
        interesados: '',
        inscriptos: '',
        cards: [],
        infoRow: [],
        activeEditar: false,
        loadingExcel: false
    }),
    methods:{
        getParametros(){
            const params = {
                institucion_id: this.parametros.institucion_id,
                ciclo_escolar_id: this.parametros.ciclo_escolar_id
            }
            if(this.parametros.grupo_id[0] == ''){
                const eliminar = this.parametros.grupo_id.shift()
                console.log(eliminar)
                params.grupo_id = this.parametros.grupo_id
            }else{
                params.grupo_id = this.parametros.grupo_id
            }
            
            return params
        },
        
        async getCarteraVencida(){
                const loading = this.$vs.loading()
            try {
                const params = this.getParametros()
                params.page = this.page
                const {data: response} = await reportes.getCarteraVencida(params)
                loading.close()
                const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = dataTable
                this.cards = response.st
            }
            catch{
                loading.close()

            }
        },
        getExcel () {
            this.loadingExcel = true
            let formData = {
                'institucion_id': this.parametros.institucion_id,
                'ciclo_escolar_id': this.parametros.ciclo_escolar_id
            }
            if(this.parametros.grupo_id != ''){
                formData.grupo_id = this.parametros.grupo_id
            }
            formData.headers = ['fullName', 'matricula', 'ciclo', 'nivel_academico', 'programa', 'conceptos', 'monto_total', 'grupos']
            this.loading = true
            setTimeout(() => {
                axios.get('/reportes/file-cartera-vencida', {
                    responseType: 'blob',
                    params: {...formData},
                    // responseType: 'arraybuffer',
                }).then(response => {
                    this.loadingExcel = false
                    if (response.data instanceof Blob) {
                        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        var filename = "";
                        const disposition = response.headers['content-disposition'];
                        if (disposition && disposition.indexOf('attachment') !== -1) {
                            const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches = filenameRegex.exec(disposition);
                            if (matches != null && matches[1]) {
                                filename = matches[1].replace(/['"]/g, '');
                                link.setAttribute('download', filename)
                            }
                        }
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                    }else{
                        throw { message: 'formatError' }
                    }
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: 'bottom-right',
                        title: 'Éxito',
                        text: 'Descarga lista'
                    })
                    this.loading = false;
                }).catch(e => {
                    this.loadingExcel = false
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'danger',
                        position: 'bottom-right',
                        title: 'Ocurrió un problema inesperado'
                    })
                });
            }, 500);
        },
    },
    watch:{
        ejecutar(){
            this.getCarteraVencida()
        },
        page(){
            this.getCarteraVencida()
        }
    }
}
</script>


<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
</style>

<style scoped>
.md-warn{
    background: #ffbc34;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 30%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-danger{
    background: #E74C3C;
    color: white;
    border-radius: 7px;
}

.md-info{
    background: #9e16aa;
    color: white;
    border-radius: 7px;
}
</style>

        